import React from 'react';
import { OrbitComponentWithState } from '../base-components/orbit-component-with-state/orbit-component-with-state';
import {observer} from "mobx-react";
import {LinkToOfferIconBox} from "./boxes/link-to-offer-icon/link-to-offer-icon.box";
import {LinkToOfferDialogCloseBox} from "./boxes/link-to-offer-dialog-close/link-to-offer-dialog-close.box";
import {CmsBannerComponent} from "../cms-banner/cms-banner.component";
import {LinkToOfferBannerBox} from "./boxes/link-to-offer-banner/link-to-offer-banner.box";
import { IModalDialogHandler } from '../../services/dialog/dialog.service.interface';
import {LinkToOfferConfiguration} from "../../services/configurations/config-data-sections/link-to-offer.configuration";
import { action, observable } from 'mobx';
import { IOffer } from '../../services/player-offerings/player-offerings.service';
import { Check } from '@sparkware/app-utils';

export interface LinkToOfferComponentProps {
    linkToOfferConfig: LinkToOfferConfiguration;
}

interface LinkToOfferComponentState {
    dialogHandler: IModalDialogHandler | null;
}

@observer
export class LinkToOfferComponent extends OrbitComponentWithState<LinkToOfferComponentProps, LinkToOfferComponentState> {

    componentDidMount() {
        super.componentDidMount();
        this._subscribe();
    }



    @observable.ref
    offerToShow: IOffer = null;

    @action.bound
    _updateOfferToShow() {
        //ofer to show is first visible one
        const offers = this.services.playerOfferings.getOffers(this.props.linkToOfferConfig);
        this.offerToShow = offers.find(offer => offer.shouldBeVisible());
        if (this.offerToShow) {
            this.offerToShow.init();
        }
    }

    private _subscribe() {
        this.reaction(
            () => { return {
                isAuthorized: this.services.user.isAuthorized,
                bannersMap: this.services.cmsBanners.bannersMap,
                hasWheelOfFortunePromotion: this.services.playerOfferings.hasWheelOfFortunePromotion
            }},
            (data) => {
                this._updateOfferToShow();
            },
            {
                fireImmediately: true
            }
        );
    }

    render() {
        if(!this.props.linkToOfferConfig && !this.offerToShow) {
            return null;
        }

        if (this.state.dialogHandler) {
            let CloseIconComponent = this.services.theme.currentTheme.icons.linkToOfferCloseIcon;

            return (
                <LinkToOfferDialogCloseBox className={'cy-link-to-offer-dialog-close-box'}
                                           onClick={() => {this._closeDialog()}}
                                           shouldAnimate={false}
                                           hasCircle={true}>
                    <CloseIconComponent size={2} sizeIsHeight />
                </LinkToOfferDialogCloseBox>
            );
        }

        const hasBannerContent = Check.isObject(this.services.cmsBanners.bannersMap[this.offerToShow?.bannerId.key]);
        if (this.offerToShow && this.offerToShow.shouldBeVisible() && hasBannerContent) {
            this.services.analytics.sendAnalytics(this.offerToShow.analyticsCategory, this.services.routing.currentRoute.data.arenaType, 'View_Floating_Button');

            return (
                <LinkToOfferIconBox className={'cy-link-to-offer-icon-box'}
                                    onClick={() => {this._onLinkToOfferClickerHandler()}}
                                    shouldAnimate={this.offerToShow.shoulUseLinkToOfferAnimation()}
                                    hasCircle={this.offerToShow.shoulUseLinkToOfferAnimation()}
                >
                    {this.offerToShow.render()}
                </LinkToOfferIconBox>
            );
        }

        return null;
    }

    public state: LinkToOfferComponentState = {
        dialogHandler: null
    };

    private _onLinkToOfferClickerHandler():void{
        this._openLinkToOfferDialog();
        this.services.analytics.sendAnalytics(this.offerToShow.analyticsCategory, this.services.routing.currentRoute.data.arenaType,'Open_Floating_Button');
    }

    private _renderBanner() {
        return (
            <LinkToOfferBannerBox className={'cy-link-to-offer-banner-box'}>
                <CmsBannerComponent key={'ARENA_LINK_TO_OFFER_BANNER'} fallbackComponent={""}
                                    templateID={this.offerToShow.bannerId.templateID}
                                    componentID={this.offerToShow.bannerId.componentID}
                                    showPlaceholder={false}/>
            </LinkToOfferBannerBox>
        );
    }

    private _openLinkToOfferDialog(): void {

        this.services.dialog.showModal((dialogHandler) => {
            this.setState({
                dialogHandler: dialogHandler
            });
            return this._renderBanner();
        }, {
            title: ' ',
            onClosed: () => this._onClosedDialog(),
            hideCloseButton: true,
            forceTransparentBackground: true,
            disableFullscreenMode: true,
            forceCentralization: true,
            hideDialogHeader: true,
            applyMaxHeight: true
        });
    }

    private _onClosedDialog() {
        this.services.analytics.sendAnalytics(this.offerToShow.analyticsCategory, this.services.routing.currentRoute.data.arenaType, 'Close_Floating_Button');
        this.setState({dialogHandler: null});
    }

    private _closeDialog = () => {
        if (this.state.dialogHandler) {
            this.state.dialogHandler.close();
        }
    };
}
